import React from 'react'
import { useAuth } from '../../contexts/AuthContext'
import { isSuperAdmin, isAdmin } from '../../utils/roleUtils'
import { User, Shield, Building } from 'lucide-react'
import './styles.scss'

export default function Profile() {
  const { user } = useAuth()

  // Format roles for display
  const getDisplayRoles = () => {
    if (!user?.roles || user.roles.length === 0) return ['User / Student'];
    
    // Securely filter out internal systemic roles for non-Super Admins
    const filteredRoles = user.roles.filter(role => {
      if (role === 'gateway_admin_realm' || role === 'gateway_admin') {
        return isSuperAdmin(user);
      }
      return true;
    });

    if (filteredRoles.length === 0) return ['User / Student'];

    return filteredRoles.map(role => {
      if (role === 'SUPER_ADMIN') return 'Super Admin';
      if (role === 'ADMIN') return 'Institution Admin';
      if (role === 'ACADEMIC_ROLE') return 'Academic Advisor';
      if (role === 'USER') return 'User';
      if (role === 'gateway_admin_realm') return 'Gateway Admin (Realm)';
      if (role === 'gateway_admin') return 'Gateway Admin (Client)';
      return role;
    });
  }

  return (
    <div className="profile-page-container">
      <header className="page-header-premium">
        <div className="hero-section">
          <User className="header-icon-large" />
          <div className="title-stack">
            <div className="hero-badge">USER PROFILE</div>
            <h1 className="dashboard-title">
              Account Info <br />
              <span className="text-gradient">Academic Portal Identity</span>
            </h1>
            <p className="subtitle">
              Manage your digital identity, institutional affiliations, and systemic role access settings.
            </p>
          </div>
        </div>
      </header>

      <main className="profile-content-wrapper">
        <div className="profile-card-glass">
          <div className="profile-avatar-large">
            <span>{user?.username?.charAt(0).toUpperCase() || 'U'}</span>
          </div>

          <h2 className="profile-user-title">{user?.username || 'User'}</h2>
          <span className="profile-user-email">{user?.email || 'No email registered'}</span>

          <div className="profile-details-grid">
            <div className="detail-row">
              <div className="detail-icon"><User size={20} /></div>
              <div className="detail-meta">
                <span className="detail-label">Username</span>
                <span className="detail-value">{user?.username || '—'}</span>
              </div>
            </div>

            <div className="detail-row">
              <div className="detail-icon"><Building size={20} /></div>
              <div className="detail-meta">
                <span className="detail-label">Institution Affiliation</span>
                <span className="detail-value">{user?.organizationName || user?.organizationShortName || 'Universal / Default'}</span>
              </div>
            </div>

            <div className="detail-row">
              <div className="detail-icon"><Shield size={20} /></div>
              <div className="detail-meta">
                <span className="detail-label">Assigned Roles</span>
                <div className="roles-pill-container">
                  {getDisplayRoles().map((role, idx) => (
                    <span key={idx} className={`role-pill ${role.toLowerCase().replace(/[^a-z0-9]/g, '-').replace(/-+/g, '-').replace(/^-|-$/g, '')}`}>
                      {role}
                    </span>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </div>
      </main>
    </div>
  )
}
